export type ApiService = 'scrm' | 'guide';

export type DeployMode = 'test' | 'prod';

export type ApiOriginBrand = 'lingshu365' | 'erkangai';

export type TestEnv =
  | 'test1'
  | 'test2'
  | 'test3'
  | 'test4'
  | 'test5'
  | 'test6';

type RuntimeEnv = TestEnv | 'prod';

type RuntimeRouteConfig = {
  apiOriginBrand: ApiOriginBrand;
  runtimeEnv: RuntimeEnv | null;
};

export type DeployConfig = {
  appTitle: string;
  appSlogan: string;
  deployMode: DeployMode;
  testEnv: TestEnv;
  /**
   * '': same-origin reverse proxy.
   * full URL: fixed backend origin, for example 'https://api.example.com'.
   */
  apiOriginBrand: ApiOriginBrand;
  apiOrigins: Record<ApiOriginBrand, Record<DeployMode, string>>;
  apiServices: Record<ApiService, string>;
  themeColor: string;
  faviconUrl: string;
  defaultAvatarUrl: string;
  ICPFilingNumber: string;
};

const runtimeRouteConfig = getRuntimeRouteConfigFromURL();
const runtimeEnvFromURL = runtimeRouteConfig.runtimeEnv;

export const deployConfig: DeployConfig = {
  appTitle: '尔康AI',
  appSlogan: '👋 尔康AI——你的药企全链路AI智能工作台',
  deployMode: runtimeEnvFromURL === 'prod' ? 'prod' : 'test',
  testEnv:
    runtimeEnvFromURL && runtimeEnvFromURL !== 'prod'
      ? runtimeEnvFromURL
      : 'test3',
  apiOriginBrand: runtimeRouteConfig.apiOriginBrand,
  apiOrigins: {
    lingshu365: {
      test: 'https://api-test.erkangai.com',
      prod: 'https://api.erkangai.com',
    },
    erkangai: {
      test: 'https://api-test.erkangai.com',
      prod: 'https://api.erkangai.com',
    },
  },
  apiServices: {
    scrm: '/lingshu-lingshu',
    guide: '/fenxiang-ai',
  },
  themeColor: '#005f9f',
  faviconUrl: './favicon.ico',
  defaultAvatarUrl: './favicon.ico',
  ICPFilingNumber: '湘ICP备2026013086号-1',
};

// 可通过 /erkangai/test2/ 指定接口域名；旧路由 /test2/ 默认走 lingshu365。
function getRuntimeRouteConfigFromURL(): RuntimeRouteConfig {
  const currentUrl = window.location.href;
  const match = currentUrl.match(
    /\/\/[^/]+\/(?:(lingshu365|erkangai)\/)?(test[1-6]|prod)(?=\/|[?#]|$)/
  );
  console.log('match Runtime route config', match);

  return {
    apiOriginBrand: (match?.[1] as ApiOriginBrand | undefined) || 'erkangai',
    runtimeEnv: (match?.[2] as RuntimeEnv | undefined) || null,
  };
}

